import { render } from "./mod_modal.vue?vue&type=template&id=67fcc15a"
import script from "./mod_modal.js?vue&type=script&lang=js"
export * from "./mod_modal.js?vue&type=script&lang=js"

import "./mod_modal.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/woodpecker/src/akkoma.dev/AkkomaGang/akkoma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__